<template>
	<div class="container contact-guide">
		<div class="title">
			<div class="back-btn" @click="goBack()">
				<i class="fa fa-arrow-left"></i>
			</div>
			<h1>How to Cancel Your Repair</h1>
		</div>
		<div class="row">
			<div class="col-md-10 offset-md-1 col-lg-8 offset-lg-2">
				<div class="faq-question">
					<h3 class="question">Step 1</h3>
					<p class="answer">
						Either use the "Manage Your Booking" form at the bottom of the page or select "<a href="/manage" target="_blank">Manage Booking</a>" from the top navigation, and enter the email address you used when booking the repair, along with the order reference. You can find your reference in your booking confirmation email.
					</p>
				</div>
				<div class="faq-question">
					<h3 class="question">Step 2</h3>
					<p class="answer">
						Scroll down the page to the box labelled "Cancel your repair appointment" and click the "Cancel My Appointment" button.
					</p>
				</div>
				<div class="faq-question">
					<h3 class="question">Step 3</h3>
					<p class="answer">
						Confirm that you're absolutely sure you wish to cancel your appointment and the enter "CANCEL-REPAIR" in the input that appears. After clicking the "OK" button, your appointment will be cancelled.
					</p>
					<p class="answer">
						<strong class="text-danger">Please be aware that this cannot be undone once you confirm, so you will need to book a new appointment if you still require a repair</strong>.
					</p>
					<p class="answer text-sm">
						Please note we require a minimum of 24 hours notice for any changes. Giving less than 24 hours notice will incur the <span v-html='currencySymbol'></span>59.00 cancellation fee.
					</p>
				</div>
			</div>
			<div class="col-lg-10 offset-lg-1">
				<!-- Manage Booking Banner -->
				<div class="container px-0 mb-5">
					<manage-booking-search-banner></manage-booking-search-banner>
				</div>
				<div class="d-flex mt-5">
					<button class="btn btn-outline-secondary mx-auto" @click="showContactForms">This didnt solve my issue</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    import {mapGetters} from "vuex"

    export default {
		methods: {
			goBack() {
				this.$emit('clearSelection');
			},

			showContactForms() {
				this.$emit('showContactForms');
			}
		},

		computed: {
			...mapGetters([
				"currencySymbol"
			])
		}
	}
</script>

<style scoped>

</style>